import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { getFileWithSignedUrl } from '../../../shared/actions/Files';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../shared/components/VerbButton';
import VerbDropdownButton from '../../../shared/components/VerbDropdownButton';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbText from '../../../shared/components/VerbText';
import { removeHTMLtagsAndDoubleQuotes } from '../../../shared/utils/StringUtils';
import CollectionSliderCard from '../../components/widgets/CollectionSliderCard';

const buttonTextDict = {
    STARTED: {
        message: 'CONTINUE',
        textId: 'BUTTON_CONTINUE'
    },
    ASSIGNED: {
        message: 'BEGIN',
        textId: 'BUTTON_BEGIN'
    },
    IN_PROGRESS: {
        message: 'CONTINUE',
        textId: 'BUTTON_CONTINUE'
    },
    COMPLETED: {
        message: 'REVIEW',
        textId: 'BUTTON_REVIEW'
    }
};

const FeaturedCollectionRow = (props) => {
    const config = useContext(RuntimeContext);
    const {
        collection: {
            collectionDescription = '',
            collectionName = '',
            subtitle = '',
            name = '',
            collectionSubtitle: collectionSubtitleForCard = '',
            description = '',
            _id,
            collectionId,
            permalink = '',
            collectionPermalink = '',
            content,
            type = '',
            status = 'ASSIGNED',
            resources = [],
            contentIds
        } = {},
        durationInMinutes = 1,
        collectionSubtitle = '',
        labelDefaultMessage = 'Featured Collection',
        handleRecommendationModalOpen,
        recommendationInfo
    } = props;

    if (!_id) {
        return null;
    }

    const cardLink = `/collection/${permalink || collectionPermalink || collectionId || _id}`;
    const cardName = collectionName || name;
    const cardDescription = removeHTMLtagsAndDoubleQuotes(
        subtitle || collectionSubtitleForCard || collectionDescription || description
    );

    const activityDefaultMessage = (content || contentIds || []).length === 1 ? 'Activity' : 'Activities';
    const activityMessageId = (content || contentIds || []).length === 1 ? 'HEADING_ACTIVITY' : 'HEADING_ACTIVITIES';

    const minuteDefaultMessage = durationInMinutes > 1 ? 'Minutes' : 'Minute';
    const minuteMessageId = durationInMinutes > 1 ? 'HEADING_MINUTES' : 'HEADING_MINUTE';

    const buttonText = buttonTextDict[status] || buttonTextDict.ASSIGNED;
    const dropdownData = [
        {
            text: 'Go to Collection',
            fontAwesomeIcon: 'fa-layer-group',
            fontAwesomeIconWeight: 'fal',
            linkProps: {
                to: {
                    pathname: `${cardLink}/path`
                }
            }
        },
        // {
        //     text: 'Recommend Collection',
        //     fontAwesomeIcon: 'fa-paper-plane',
        //     fontAwesomeIconWeight: 'fal',
        //     onClick: handleRecommendationModalOpen
        // }
    ];

    if (status && status === 'COMPLETED' && resources?.length) {
        dropdownData.push({
            text: 'Reference Files',
            fontAwesomeIcon: 'fa-download',
            fontAwesomeIconWeight: 'fal',
            onClick: () => {
                // eslint-disable-next-line no-unused-expressions
                resources || [].forEach((item) => getFileWithSignedUrl(config.pathsWeb, item.url.split(' ').join('+')));
            }
        });
    }

    const details = (
        <>
            <div className={'details-activities'}>
                <i className={'fal fa-book'} />
                {`${(content || contentIds || []).length} `}
                <VerbText defaultMessage={activityDefaultMessage} messageId={activityMessageId} />
            </div>
            <div className={'details-time'}>
                <i className={'fal fa-clock'} />
                {`${durationInMinutes} `}
                <VerbText defaultMessage={minuteDefaultMessage} messageId={minuteMessageId} />
            </div>
        </>
    );

    if (!props.collection.recommendationInfo && (recommendationInfo || !isEmpty(recommendationInfo))) {
        props.collection.recommendationInfo = recommendationInfo;
    }

    return (
        <div className={'featured-collection-container container'}>
            <div className={'row no-horizontal-margin featured-heading-container'} style={{ paddingBottom: 0 }}>
                <VerbHeading
                    className={'col-12 home-row-wrapper-heading'}
                    hNumber={5}
                    messageId={' '}
                    defaultMessage={labelDefaultMessage}
                />
            </div>
            <div className={'row'}>
                <div className={'col-12 col-sm-12 col-md-3 collection-image'}>
                    <CollectionSliderCard
                        cardOrientation={'vertical'}
                        handleRecommendationModalOpen={handleRecommendationModalOpen}
                        isUserCollection={_id && collectionId}
                        collection={props.collection}
                        className={'col-12 col-sm-12'}
                        thumbnailDimension={{ h: 450, w: 450 }} // the actual size of the fetched image. This should ideally be larger than the card
                        hideDetailsOverlay={true}
                    />
                </div>
                <div
                    className={'collection-text-container col-12 col-sm-12 col-md-9 no-padding'}
                    style={collectionSubtitle.length > 40 ? { marginTop: 50 } : {}}
                >
                    <div className={'row no-padding'}>
                        <div className={'col-12 col-sm-12 col-md-12 col-lg-8 no-padding description-container'}>
                            <div className={'details'}>
                                {type === 'STANDARD' ? 'CERTIFIED COLLECTION' : 'COLLECTION'}
                            </div>
                            <VerbHeading hNumber={2} defaultMessage={cardName.trim()} className={'long-card-title'} />
                            <div
                                className={`collection-text-description ${
                                    cardName.trim().length > 50 ? 'long-title' : ''
                                }`}
                            >
                                {cardDescription}
                            </div>
                            <div className={'collection-detail-container details-mobile'}>
                                <div className={'row no-padding'}>{details}</div>
                            </div>
                            <div className={'button-row row no-horizontal-margin no-padding'}>
                                <div className={`col-12 col-sm-12 col-md-9 no-padding`}>
                                    <Link className={'card-link'} to={cardLink}>
                                        <VerbButton
                                            className={'cta-button'}
                                            textId={buttonText.textId}
                                            defaultMessage={buttonText.message}
                                        />
                                    </Link>
                                </div>
                                <div className={'col-md-3 col-4 no-padding vertical-cards-popover-button-container'}>
                                    <VerbDropdownButton
                                        fontAwesomeIcon={'fa-ellipsis-h'}
                                        dropdownData={dropdownData}
                                        className={'vertical-cards-popover-button'}
                                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                        popoverPlacement={'top'}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={'d-none d-md-block d-lg-block d-xl-block col-1 border-line'}>
                            <div className={'detail-border'} />
                        </div>
                        <div className={'collection-detail-container col-12 col-sm-2 col-md-2 col-lg-2 no-padding'}>
                            {details}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

FeaturedCollectionRow.propTypes = {
    collection: PropTypes.object,
    collectionSubtitle: PropTypes.string,
    labelDefaultMessage: PropTypes.string,
    durationInMinutes: PropTypes.number,
    handleRecommendationModalOpen: PropTypes.func,
    recommendationInfo: PropTypes.object
};

export default FeaturedCollectionRow;
